import React from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../../../../components/Button'
import Field from '../../../../components/Form/Field'

import { BUSINESS_NAME } from '../fields'

import useStyles from '../../../../styles/common/stepForms'

const stepFields = [BUSINESS_NAME]

function BusinessNameStep({ formik, handleStepChange }) {
  const commonClasses = useStyles()

  const { t } = useTranslation()

  const handleContinue = () => {
    handleStepChange(stepFields)
  }

  return (
    <>
      <div className={commonClasses.stepTitle}>{t('What business name should be displayed on the ad?')}</div>
      <div className={commonClasses.stepBody}>
        <Field formik={formik} name={BUSINESS_NAME} placeholder="Business name" autoComplete="off" maxLength={25} />
      </div>
      <div className={commonClasses.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

export default BusinessNameStep
